export const getDemographicStyle = (_, { palette = {} }) => ({
  demographicContainer: {
    '& > label': {
      marginTop: 24,
    },

    '& button.toggle-dimensions': {
      color: palette.themePrimary,
      padding: 0,

      '& .ms-Button-label': {
        margin: 0,
      },
    },

    '& .dimensions': {
      display: 'grid',
      gridTemplateColumns: 'auto auto auto',
      columnGap: '10px',
    },

    '& .error-message': {
      color: palette.redDark,
      marginTop: 8,
    },
  },
});
